<template>
  <q-btn
    class="q-px-md q-py-sm primary-button width"
    no-caps
    no-wrap
    rounded
    :class="{ small: small, medium: medium, large: large, xLarge: xLarge }"
    @click="$emit('onClick')"
  >
    <template v-slot:default>
      <slot name="tooltip"></slot>
      <div class="row items-center justify-center">
        <slot name="left-icon"></slot>
        <span class="label-btn" :style="{ color: colorLabel }">{{
          label
        }}</span>
        <slot name="right-icon"></slot>
      </div> </template
  ></q-btn>
</template>

<script>
export default {
  name: "PrimaryButton",
  props: {
    label: String,
    colorLabel: { type: String, default: "var(--q-neutral-0,#FFF)" },
    width: {
      type: String,
      default: "fit-content",
    },
    small: {
      type: Boolean,
      default: false,
    },
    medium: {
      type: Boolean,
      default: false,
    },
    large: {
      type: Boolean,
      default: false,
    },
    xLarge: {
      type: Boolean,
      default: false,
    },
  },
  emits: ["onClick"],

  setup() {
    return {};
  },
};
</script>

<style scoped>
:is(.primary-button, .q-btn) {
  background: var(--q-primary, #fe4e64);
}

.primary-button.q-btn:before {
  box-shadow: none;
}

.label-btn {
  letter-spacing: -0.25px;
  font-family: Montserrat;
  font-style: normal;
  font-weight: 600;
  line-height: 20px;
}

:is(.large, .medium, .xLarge) {
  font-size: 16px;
}

.small {
  font-size: 14px;
  height: 36px;
}

.large {
  height: 48px;
}

.medium {
  height: 42px;
}

.xLarge {
  height: 56px;
}

.width {
  width: v-bind(width);
}
</style>
